import { render, staticRenderFns } from "./RepaymentListItem.vue?vue&type=template&id=2dfd5115&scoped=true&"
import script from "./RepaymentListItem.vue?vue&type=script&lang=js&"
export * from "./RepaymentListItem.vue?vue&type=script&lang=js&"
import style0 from "./RepaymentListItem.vue?vue&type=style&index=0&id=2dfd5115&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd5115",
  null
  
)

export default component.exports